module.exports = __webpack_public_path__ + "media/images/flags/RO-fe914c54277e180c1623dc27173cf1bc.svg";